const ROUTE_HISTORY_KEY = "popmart_route_history"
const MAX_HISTORY_SIZE = 5

export interface RouteHistoryItem {
	path: string
	timestamp: number
	params?: Record<string, string>
}

export class RouteHistoryManager {
	private static instance: RouteHistoryManager

	private constructor() {}

	static getInstance(): RouteHistoryManager {
		if (!RouteHistoryManager.instance) {
			RouteHistoryManager.instance = new RouteHistoryManager()
		}
		return RouteHistoryManager.instance
	}

	/**
	 * 添加路由记录
	 */
	push(path: string, params?: Record<string, string>): void {
		if (typeof window === "undefined") return

		try {
			const history = this.getHistory()
			const newItem: RouteHistoryItem = {
				path,
				timestamp: Date.now(),
				params,
			}

			// 避免重复添加相同路径
			if (history.length > 0 && history[0].path === path) {
				return
			}

			// 添加到开头，保持最新的在前面
			history.unshift(newItem)

			// 保持最大数量限制
			if (history.length > MAX_HISTORY_SIZE) {
				history.splice(MAX_HISTORY_SIZE)
			}

			sessionStorage.setItem(ROUTE_HISTORY_KEY, JSON.stringify(history))
		} catch (error) {
			console.warn("Failed to save route history:", error)
		}
	}

	/**
	 * 获取路由历史
	 */
	getHistory(): RouteHistoryItem[] {
		if (typeof window === "undefined") return []

		try {
			const stored = sessionStorage.getItem(ROUTE_HISTORY_KEY)
			return stored ? JSON.parse(stored) : []
		} catch (error) {
			console.warn("Failed to get route history:", error)
			return []
		}
	}

	/**
	 * 获取上一个路由
	 */
	getPrevious(): RouteHistoryItem | null {
		const history = this.getHistory()
		return history.length > 1 ? history[1] : null
	}

	/**
	 * 检查是否从指定路径来的
	 */
	isFromPath(path: string): boolean {
		const previous = this.getPrevious()
		return previous ? previous.path === path : false
	}

	/**
	 * 检查是否从指定路径列表中的任一路径来的
	 */
	isFromPaths(paths: string[]): boolean {
		const previous = this.getPrevious()
		return previous ? paths.includes(previous.path) : false
	}

	/**
	 * 检查是否从匹配模式的路径来的
	 */
	isFromPattern(pattern: RegExp): boolean {
		const previous = this.getPrevious()
		return previous ? pattern.test(previous.path) : false
	}

	/**
	 * 清空历史记录
	 */
	clear(): void {
		if (typeof window === "undefined") return

		try {
			sessionStorage.removeItem(ROUTE_HISTORY_KEY)
		} catch (error) {
			console.warn("Failed to clear route history:", error)
		}
	}

	/**
	 * 获取当前路由（最新的一条）
	 */
	getCurrent(): RouteHistoryItem | null {
		const history = this.getHistory()
		return history.length > 0 ? history[0] : null
	}
}

// 导出单例实例
export const routeHistory = RouteHistoryManager.getInstance()
